import ReactDom from 'react-dom';

const getTypeModal = (type) => {
  const baseType = {
    companySetting: 'new_company_settings',
    orgChart: 'ch-prompt-delete',
    employee: 'employee_modal',
    wla: 'employee_modal',
    detailCvc: 'cvc-detail-container',
    business_process: 'businessProcess',
    bispro: 'bispro_modal',
    bispro_revamp: 'bispro_modal_slim',
    notification: 'notification_modal',
    boardInfo: 'modal_boardInformation',
  };
  return baseType[type] ?? '';
};

function Modal(props) {
  if (!props?.modal) {
    return null;
  }

  return ReactDom.createPortal(
    <div className="layout_modal">
      <div
        className={`${!props?.classIdentifier
          ? 'modal_background'
          : `modal_background ${props?.classIdentifier}`
        }`}
      />
      <div
        className={`container_modal ${getTypeModal(props?.type)}`}
        style={props?.style}
      >
        <div className="container_modal-body">{props?.children}</div>
      </div>
    </div>,
    document.getElementById(props?.id ?? 'portal'),
  );
}

export default Modal;
